/**
 * Prefixo das classes dos seletores. Com ele o menu aberto tem a classe `rs__menu`, que o rodape de formulario usa para
 * saber que o Esc e do menu; sem prefixo as classes sao geradas e nao dao para consultar.
 */
export const SELECT_CLASS_PREFIX = 'rs';
